module.exports = __webpack_public_path__ + "static/media/arrow-up-gray.8987fec3.svg";